/*globals $:false ga:false Sentry:false */

import utils from '../cob.utils.js';

// Model for the current App name, the menu items and the current loggged in user.
var AppInfo = function(core) {

    var customized = false;

    var _appModel = {
        //the name of the current App
        appId: undefined,

        //the name of the current App Instance
        appInstanceId: undefined,

        // the base64 enconded application logo
        appLogo: undefined,

        //an array of objects with name and href keys, that represent links to other CoB apps
        apps: [],

        //an array of objects with name and href keys, that represent the menu items of the current app
        opts: [],

        //an object that holds the base url for our applications. This is usefull for CORS.
        appUrls: {},

        //the username of the currently logged in user
        username: "anonymous",

        //the username of the currently logged in user when a substitution is taking place
        realUsername: undefined,

        analytics: {
            cobSite: undefined
        },

        customInfo: {},

        casURL:undefined
    };

    var _userDetails = {
        loggedInUser: {},
        realUser: {}
    };

    var _loadUserDetails = function(onDone) {

        var url = _getAppUrlOrDefault("userm", 40780) + '/userm/user/loggedin';

        $.ajax({
            'url': url,
            'type': 'get',
            contentType: 'application/json',
            xhrFields: {
                withCredentials: true
            },
            crossDomain: true,
            ignoreErrors: true, //we don't want to go to forbidden, only show no logs
            success: function(data) {
                _userDetails = data;
                _userDetails.loggedInUser.groups = data.loggedInUser.groups ?
                                      data.loggedInUser.groups.map(function(group){return group.name}) :
                                      undefined;
            },
            error: function(req) {
                window.console.log("APPINFO:error: " + req.status + " : " + req.statusText + ":" + req.responseText);
                if (req.status == 401) {
                    core.publish("app:security:user-changed");
                }
            },
            complete: function() {
                _customizeIfNeeded(true);
                if (onDone) onDone();
            }
        });
    };

    var _updateAppModel = function(onDone) {
        $.ajax({
            'url': 'app/info',
            'type': 'get',
            'dataType': 'json',
            success: function(data) {
                if (data) {
                    _appModel.appId = data.appId;
                    _appModel.appInstanceId = data.appInstanceId;
                    _appModel.appLogo = data.appLogo;
                    _appModel.apps = data.appMenus;
                    _appModel.opts = data.itemMenus;
                    _appModel.appUrls = data.appUrls;
                    _appModel.username = data.username;
                    _appModel.realUsername = data.realUsername;
                    _appModel.analytics = data.analytics;
                    _appModel.customInfo = data.customInfo;

                   // we keep the original ones to re-run customizations on user change
                   _appModel.original_apps = _appModel.apps;
                   _appModel.original_opts = _appModel.opts;
                }
            },
            error: function(req) {
                window.console.log("APPINFO:error: " + req.status + " : " + req.statusText + ":" + req.responseText);
            },
            complete: function() {
                if (onDone) onDone();
            }
        });
    };

    const _customizeIfNeeded = function(forced){
       if (customized && !forced) return;

       if(!_appModel.original_apps || !_appModel.original_opts) return;

       const customizers = core.getMenuCustomizers ? core.getMenuCustomizers() : [];
       if(customizers.length > 0){
          // we clone the info from the server, to customize from scratch
          _appModel.apps = [..._appModel.original_apps];
          _appModel.opts = [..._appModel.original_opts];

          customizers.forEach((customizer) => customizer({apps: _appModel.apps, menus: _appModel.opts}));
          customized = true;
       }
    }

    var _updateAppVersion = function(onDone) {
        $.ajax({
            'url': 'VERSION',
            'type': 'get',
            'dataType': 'text',
            success: function(data) {
                if (data) {
                    _appModel.version = data.trim();
                }
            },
            error: function(req) {
                window.console.log("VERSION:error: " + req.status + " : " + req.statusText + ":" + req.responseText);
            },
            complete: function() {
                if (onDone) onDone();
            }
        });
    }

    var _reset = function() {
        // reset previous data
        _appModel = {
            // these don't change with the user
            appId: _appModel.appId,
            appInstanceId: _appModel.appInstanceId,
            appLogo: _appModel.appLogo,

            apps: [],
            opts: [],
            appUrls: {},
            username: "anonymous",
            analytics: {},
            customInfo: {}
        };

        _userDetails = {
            loggedInUser: {},
            realUser: {}
        };
    };

    var _updateUserInfo = function(onDone) {
        _loadUserDetails(onDone);
    };

    var _updateAppInfo = function(onDone) {
        _reset();

        _updateAppModel(function() {
            //todo jone retirar este HACK assim que tivermos analytics a s�rio
            if (typeof ga !== 'undefined') {
                ga('set', 'dimension1', _appModel.username);

                if (_appModel.analytics.cobSite) {
                    ga('set', 'dimension2', _appModel.analytics.cobSite);
                }
            }
            if(typeof Sentry !== 'undefined') Sentry.configureScope((scope) => {
                scope.setUser({"username": _appModel.username });
                if (_appModel.analytics.cobSite) scope.setTag("cobSite", _appModel.analytics.cobSite);
            });

            // There is nothing to know about user anonymous
            if (_appModel && _appModel.username !== undefined && _appModel.username !== 'anonymous') {

                _updateUserInfo(function() {
                    //todo jone retirar este HACK assim que tivermos analytics a s�rio
                    if (typeof ga !== 'undefined') {
                        try {
                            _userDetails.loggedInUser.groups.every(function(group) {
                                if ((/ORG /).exec(group)) {
                                    ga('set', 'dimension3', group);
                                    return false;
                                }
                            })
                        } catch (e) { /* do nothing */ }
                    }
                    core.publish('updated-app-info');
                    if (onDone) {onDone();}
                });

            } else {
                core.publish('updated-app-info');
                if (onDone) {onDone();}
            }

        });
    };

    var _getAppUrlOrDefault = function(app, defaultPort) {
        var appUrl,
            host;

        if (_appModel.appUrls[app]) {
            return _appModel.appUrls[app];
        }

        appUrl = utils.userSession.getProtocol() + "//";

        host = utils.userSession.getHost();
        appUrl += host.replace(/(.*):(\d+)/g, "$1");
        appUrl += ":" + defaultPort;

        return appUrl;
    };

    return {
        resetInfo: _reset,
        updateAppVersion: _updateAppVersion,
        updateAppInfo: _updateAppInfo,
        updateUserInfo: _updateUserInfo,

        isCasEnabled: function(){
            // we can't use CAS when serving from localhost
            // or if we get the noCas query param
            const noCasPresent = new URL(window.location).searchParams.has('noCas');
            return _appModel.appUrls.cas !== undefined && window.location.hostname !== 'localhost' && !noCasPresent;
        },

        getBaseUrlForCas: function(){
            return _appModel.appUrls.cas;
        },

        getAppInfoModel: function(forceRebuild) {
            // HACK: we call this everytime because the load may happen before having customizers configured
            _customizeIfNeeded(forceRebuild);
            return utils.clone(_appModel);
        },

        getCustomInfo: function(name){
            var customInfo = _appModel.customInfo[name];

            return customInfo ? customInfo : [];
        },

        getCurrentLoggedInUser: function() {
            return _appModel.username;
        },

        getRealUser: function() {
            return _appModel.realUsername;
        },

        getCurrentLoggedInUserUri: function(){
            return  _userDetails.loggedInUser._links.self;
        },

        getUserProfileUrl: function(){
            return _getAppUrlOrDefault("userm", 40780) + "/#/user/" + _userDetails.loggedInUser.id;
        },

        getGroups: function(){
            return _userDetails.loggedInUser.groups;
        },

        userHasGroup: function(groupName) {
            return (_userDetails.loggedInUser.groups &&
                    _userDetails.loggedInUser.groups.indexOf(groupName) !== -1);
        },

        userHasAtLeastOneGroup: function(groups) {
            if (_userDetails.loggedInUser.groups) {
                return groups.some((group) => {
                    // If the group starts and ends with "/" it will use a regex for the comparison,
                    // unless the group is "//"
                    if(group.indexOf("/") === 0 && group.lastIndexOf("/") && group.length > 2){
                        const groupRegexp = new RegExp(
                           "^" + group.substring(1, group.length-1).replace(/\\{2}/g, "\\") + "$"
                        );

                        return _userDetails.loggedInUser.groups.some((userGroup) => groupRegexp.test(userGroup));
                    } else {
                        return _userDetails.loggedInUser.groups.includes(group);
                    }
                });
            }

            return false;
        },

        getUserSubstitute: function() {
            return _userDetails.loggedInUser.substitute;
        },

        getUsersToSubstitute: function(){
            var usersToSubstitute = _userDetails.realUser ?
                   _userDetails.realUser.substitutedUsers :
                   _userDetails.loggedInUser.substitutedUsers;

            //If the user is impersonating another one
            //we disable the impersonated user in the users to substitute list
            if(_userDetails.realUser && usersToSubstitute){
                usersToSubstitute.some(function(user){
                    if(user.username.toLowerCase() === _appModel.username.toLowerCase()){
                        user.cannotImpersonate = true;
                        return true;
                    }
                });
            }

            return usersToSubstitute;
        },

        getBaseAppUrl: function(app) {
            return _appModel.appUrls[app];
        },

        getLogMUrl: function() {
            return _getAppUrlOrDefault("logm", 40480);
        },
        getUserMUrl: function() {
            return _getAppUrlOrDefault("userm", 40780);
        },
        getRecordMUrl: function(withPage) {
            var page = _appModel.appUrls['recordm.page'] || 'index.html';
            return _getAppUrlOrDefault("recordm", 40280) + ( withPage ? '/' + page : '');
        }
    };
};

export default AppInfo;
